var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BranchForm',{attrs:{"buttonTitle":"Создать","cardTitle":_vm.$t('pages.newBranch')},on:{"saveBranch":_vm.handleAddBranch,"saveBankAccount":_vm.handleAddBank}})
}
var staticRenderFns = []

export { render, staticRenderFns }